import { backgroundPlugin, progressBackgroundPlugin, CenterBarLabelsPlugin } from "./gradientHelper";
//import ChartDataLabels from 'chartjs-plugin-datalabels';
import { formatterFunctions } from "./formatters";
import { BorderColor } from "@mui/icons-material";
import { ccColorLightTeal, ccColorDarkTeal, ccColorYellow, ccColorOrange } from "../components/helpersStyles";

export const defaultValues = {
  animation: {
    duration: 700,
    easing: 'easeOutCubic'
  },
};


export const metadataBarChart = {
  ccWidth: 400,
  ccHeight: 210,
  ccGenerateAnimation: {enabled: false, numFrames: 10},
  type: 'bar',

  data: {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Revenue',
        data: [32, 45, 38, 52, 48, 60],
        borderRadius: 10,
        borderSkipped: false,
        barThickness: 28,
        //backgroundColor: ['#60a5fa', '#2563eb']
        backgroundColor: [ccColorLightTeal, ccColorDarkTeal]
      },
      /*
      {
        label: 'Revenue',
        data: [32, 45, 38, 52, 48, 60],
        borderRadius: 10,
        borderSkipped: false,
        barThickness: 28,
        backgroundColor: [ccColorLightTeal, ccColorDarkTeal]
        //backgroundColor: ccColorDarkTeal
      }
        */
    ]
  },

  options: {
    responsive: false,
    maintainAspectRatio: false,
    animation: defaultValues.animation,

    plugins: {
      legend: { display: false },
      tooltip: { enabled: false},
      title: {display:false, text: "Title", color: '#555555', font: {family: "Inter", size: 24}},
      customCanvasBackgroundColor: {
        color: '#ffffff'
      },
      progressBackground: {
        display: false,
      },
      centerBarLabels: {
        display: false,
      }
    },

    scales: {
      x: {
        display: true,
        grid: { display: false, color: '#cccccc', },
        ticks: {color: '#999999' },
        border: {color: '#999999'} //axis color
      },
      y: {
        display: true,
        beginAtZero: true,
        grid: {
          color: '#cccccc',
          display: false,
          drawTicks: false
        },
        ticks: {color: '#999999' },
        border: {color: '#999999'} //axis color
      }
    }
  },
  plugins: [backgroundPlugin]

}
export const metadataBarChartHorizontal = {
  ccWidth: 400,
  ccHeight: 210,
  ccGenerateAnimation: {enabled: false, numFrames: 10},
  type: 'bar',

  data: {
    labels: ['Jan', 'Feb', 'Mar', 'Apr'],
    datasets: [
      {
        label: 'Revenue',
        data: [32, 45, 38, 52],
        borderRadius: 10,
        borderSkipped: false,
        barThickness: 28,
        //backgroundColor: ['#60a5fa', '#2563eb']
        backgroundColor: [ccColorLightTeal, ccColorDarkTeal]
      }
    ]
  },

  options: {
    indexAxis: 'y',
    responsive: false,
    animation: defaultValues.animation,

    plugins: {
      legend: { display: false },
      tooltip: { enabled: false},
      title: {display:false, text: "Title", color: '#555555', font: {family: "Inter", size: 24}},
      customCanvasBackgroundColor: {
        color: '#ffffff'
      },
      progressBackground: {
        display: false,
      },
      centerBarLabels: {
        display: false,
      }
    },

    scales: {
      x: {
        grid: { display: false, color: '#cccccc', },
        ticks: {color: '#999999', },
        border: {color: '#999999'},
      },
      y: {
        beginAtZero: true,
        grid: {
          display: false,
          drawTicks: false,
          color: '#cccccc',
        },
        ticks: {color: '#999999',  },
        border: {color: '#999999'} //axis color        
      }
    }
  },
  plugins: [backgroundPlugin]

}
export const metadataProgressBar = {
  ccWidth: 400,
  ccHeight: 210,
  ccGenerateAnimation: {enabled: false, numFrames: 10},
  type: 'bar',
  data: {
    labels: ['Progress'],
    datasets: [
      {
        minBarLength: 0,
        data: [65],
        //backgroundColor: '#3b82f6',
        //backgroundColor: ['#60a5fa', '#2563eb'],
        backgroundColor: [ccColorLightTeal, ccColorDarkTeal],
        borderWidth: 0,
        borderRadius: 10,
        barThickness: 20
      }
    ]
  },
  options: {
    responsive: false,
    maintainAspectRatio: false,
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      tooltip: { enabled: false },
      title: {display:false, text: "Title", color: '#555555', font: {family: "Inter", size: 24}},
      progressBackground: {
        backgroundColor: '#e5e7eb',
        barThickness: 20,
        borderRadius: 10
      },
      customCanvasBackgroundColor: {
        color: '#ffffff'
      },
      centerBarLabels: {
        //ccShowProgress: true,
        ccShowProgressAsPercentage: true,
        display: true,
        font: {size: 14, family: 'Inter',},
        color: '#fff',
        formatter: formatterFunctions.progressBarFormatter,
      },
    },
    scales: {
      x: {
        offset: true,
        min: 0,
        max: 100,
        display: false,
        grid: {display: false, drawTicks: false,},
        ticks: {color: '#999999', callback: function(value, index, ticks) {
                  // Only show the first or last tick
                  return value
                  /*
                  if (index === 0 || index === ticks.length - 1) {
                    return value;
                  }
                  return ''; // hide all other ticks
                  */
                } 
              }        
      },
      y: {
         grid: {display: false, drawTicks: false,},
         display: false
      }
    }
  },
  plugins: [progressBackgroundPlugin, backgroundPlugin, CenterBarLabelsPlugin]
}
export const metadataPieChart = {
  ccWidth: 400,
  ccHeight: 210,
  ccGenerateAnimation: {enabled: false, numFrames: 10},
  type: 'pie',

  data: {
    labels: ['Cat1', 'Cat2', 'Cat3', 'Cat4'],
    datasets: [
      {
        borderWidth: 0,
        borderColor: '#999999',
        spacing: 2,
        label: 'Revenue',
        data: [20,30,50,10],
        borderRadius: 10,
        //borderSkipped: false,
        //backgroundColor: ['#6366F1', '#A5B4FC', '#E0E7FF', '#EEF2FF'] //indigo
        //backgroundColor : ['#0F766E', '#2DD4BF', '#99F6E4', '#ECFEFF'] // teal
        //backgroundColor: ['#BE185D', '#EC4899', '#F9A8D4', '#FDF2F8'] //pink
        //backgroundColor: ['#1D4ED8', '#3B82F6', '#93C5FD', '#EFF6FF'] //blue
        backgroundColor: ['#9bcccd', '#6f9ea8', '#437082', '#17425d'] //ccteal
        //backgroundColor: ['#fbbc3d', '#f4ac40', '#ef9c42', '#ea8c44']

        //backgroundColor: ccColorDarkTeal
      },
    ]
  },

  options: {
    hover: {
      mode: null
    },
    responsive: false,
    maintainAspectRatio: false,
    animation: defaultValues.animation,

    plugins: {
      legend: { display: true },
      tooltip: { enabled: false},
      title: {display:false, text: "Title", color: '#555555', font: {family: "Inter", size: 24}},
      customCanvasBackgroundColor: {
        color: '#ffffff'
      },
      progressBackground: {
        display: false,
      },
      centerBarLabels: {
        display: false,
      }
    },

    scales: {
      x: {
        display: false,
        grid: { display: false, color: '#cccccc', },
        ticks: {color: '#999999' },
        border: {color: '#999999'} //axis color
      },
      y: {
        display: false,
        beginAtZero: true,
        grid: {
          color: '#cccccc',
          display: false,
          drawTicks: false
        },
        ticks: {color: '#999999' },
        border: {color: '#999999'} //axis color
      }
    }
  },
  plugins: [backgroundPlugin]

}

export const metadataDoughnutChart = {...metadataPieChart,
                                        options: {...metadataPieChart.options, cutout: '70%'}
}

export const metadataHalfPieChart = {...metadataPieChart,
                                        options: {...metadataPieChart.options, 
                                                    circumference: 180, rotation: -90,}
}
export const metadataHalfDoughnutChart = {...metadataPieChart,
                                        options: {...metadataPieChart.options, cutout: '70%', 
                                                    circumference: 180, rotation: -90,}
}

export const metadataLineChart = {
  ccWidth: 400,
  ccHeight: 210,
  ccGenerateAnimation: {enabled: false, numFrames: 10},
  type: 'line',

  data: {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'],
    datasets: [
      {
        label: 'Revenue',
        data: [32, 45, 38, 52, 48, 60],
        borderRadius: 10,
        borderSkipped: false,
        borderWidth: 3,
        //backgroundColor: ['#60a5fa', '#2563eb']
        //pointBackgroundColor: '#2563eb',
        pointBackgroundColor: ccColorDarkTeal,
        pointRadius: 3,
        borderColor: ccColorLightTeal, //line color
        //borderColor: '#60a5fa', //line color
        tension: 0.2, // 0 --> 1
      },
    ]
  },

  options: {
    responsive: false,
    maintainAspectRatio: false,
    animation: defaultValues.animation,

    plugins: {
      legend: { display: false },
      tooltip: { enabled: false},
      title: {display:false, text: "Title", color: '#555555', font: {family: "Inter", size: 24}},
      customCanvasBackgroundColor: {
        color: '#ffffff'
      },
      progressBackground: {
        display: false,
      },
      centerBarLabels: {
        display: false,
      }
    },

    scales: {
      x: {
        display: true,
        grid: { display: false, color: '#cccccc', },
        ticks: {color: '#999999' },
        border: {color: '#999999'} //axis color
      },
      y: {
        display: true,
        beginAtZero: true,
        grid: {
          color: '#cccccc',
          display: false,
          drawTicks: false
        },
        ticks: {color: '#999999' },
        border: {color: '#999999'} //axis color
      }
    }
  },
  plugins: [backgroundPlugin]

}


export const allChartsMetadata = [{title: 'Vertical Bars', metadata: metadataBarChart}, {title: 'Horizontal Bars', metadata: metadataBarChartHorizontal}, {title: 'Progress Bar', metadata: metadataProgressBar}, {title: 'Pie', metadata: metadataPieChart}, {title: 'Doughnut', metadata: metadataDoughnutChart}, {title: 'Half Pie', metadata: metadataHalfPieChart}, {title: 'Half Doughnut', metadata: metadataHalfDoughnutChart}, {title: 'Line', metadata: metadataLineChart}]
